import Section from 'evcharging/containers/layout/Section';
import React from 'react';
import perfectChoice from 'evcharging/assets/ev-charger/perfectChoice.png';
import device from 'evcharging/assets/ev-charger/device.png';
import Container from 'evcharging/components/Container';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import Title from 'evcharging/components/Title';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import LinkButton from 'evcharging/components/LinkButton';
import Spacer from 'evcharging/components/Spacer';
import PerfectItem, { PerfectItemProps } from 'evcharging/containers/ev-charger/PerfectItem';
import { useRouter } from 'next/router';
import useI18n from 'evcharging/hooks/useI18n';
import Mobile from 'evcharging/components/Mobile';
import Desktop from 'evcharging/components/Desktop';
import Image from 'next/image';

const PerfectChoice = () => {
  const { pathname } = useRouter();
  const { t } = useI18n();

  const items: PerfectItemProps[] = [
    {
      question: t('charger.perfect1.question'),
      answer: [t('charger.perfect1.answer')],
    },
    {
      question: t('charger.perfect2.question'),
      answer: [t('charger.perfect2.answer')],
    },
    {
      question: t('charger.perfect3.question'),
      answer: [t('charger.perfect3.answer')],
    },
    {
      question: t('charger.perfect4.question'),
      answer: [t('charger.perfect4.answer')],
    },
    {
      question: t('charger.perfect5.question'),
      answer: [t('charger.perfect5.answer')],
    },
    {
      question: t('charger.perfect6.question'),
      answer: [t('charger.perfect6.answer')],
    },
  ];

  return (
    <Section
      backgroundSize={'cover'}
      backgroundColor={'#f6f8f9'}
      backgroundImage={`url(${perfectChoice})`}
      backgroundPosition={'center'}
    >
      <Container>
        <Responsible fractions={[63]} justifyContent={'flex-start'} mobileReverse mobileCenter>
          <Box>
            <Spacer value={70} mobile={0} />
            <Desktop>
              <Title maxWidth={496} variant={'h2'}>
                {t('charger.perfect.title')}
              </Title>
            </Desktop>
            <Mobile>
              <Title maxWidth={496} variant={'h2'} margin={'0 auto'}>
                {t('charger.perfect.title')}
              </Title>
            </Mobile>
            <Spacer value={24} />
            <LinkButton href={CONTACT_US_ANCHOR}>
              {t('form.lead.button')}
            </LinkButton>
          </Box>
          <Image src={device} alt={t('charger.perfect.alt')} width={277} height={369} />
        </Responsible>
        <Spacer value={70} mobile={24} />
        <Responsible fractions={[31, 31, 31]}>
          {items.slice(0, 3).map((item, index) => (
            <PerfectItem {...item} key={index} />
          ))}
        </Responsible>
        <Spacer value={40} mobile={0} />
        <Responsible fractions={[31, 31, 31]}>
          {items.slice(3, 6).map((item, index) => (
            <PerfectItem {...item} key={index} />
          ))}
        </Responsible>
      </Container>
    </Section>
  );
};

export default PerfectChoice;
